module.exports = "<h1>Page Not Found</h1>\n<a routerLink=\"../\" class=\"btn btn-default\">Go Back </a>\n"